<template>
  <div class="drawer">
    <el-drawer
      size="850px"
      title="盘点详情"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="line-height: 44px">
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">盘点期号：</span>
            <span class="value">{{ detail.no }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">盘点人：</span>
            <span class="value">{{ detail.inventoryUser?detail.inventoryUser.title:'--'  }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">盘点日期：</span>
            <span class="value">
              {{ detail.inventoryTime}}
            </span>
          </el-col>

        </el-row>
      </div>
      <div style="max-height:700px;overflow-y: scroll;margin-left:30px;margin-top:10px;">
        <el-table
          ref="table"
          :data="tableData"
          row-class-name="row-expand-cove"
          style="width: 100%"
        >
          <el-table-column label="名称">
            <template slot-scope="props">
              {{ props.row.productName }}
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="props"> 
              <span>{{ props.row.skuName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="props">
              <span>{{ props.row.stockUnit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="60">
            <template slot-scope="props">
              <span>{{ props.row.actualCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" >
            <template slot-scope="props">
              <span>{{ props.row.remark }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      detail: {},
      outCount:0,
      tableData: [],
    };
  },
  props: {
    id: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDetail();
    });
  },
  methods: {
    handleClose() {
      this.$emit("submit");
    },
    // 提交
    getDetail() {
      let params = {
        id: this.id,
      };
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url66 + "api/inventory/info", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            console.log(this.detail, "出库详情1111");
            this.formatTableData(this.detail.orderItems);
          }
        });
    },
    formatTableData(orderItems) {
      let list = [];
      let arr_goodsNameSkus = [];
      let outCount=0;
      for (let i = 0; i < orderItems.length; i++) {
        let goodsNameSkus = orderItems[i].goodsId + orderItems[i].skus;
        let index = arr_goodsNameSkus.indexOf(goodsNameSkus);
        outCount+=orderItems[i].outCount
        console.log(outCount,'outCount');
        if (index === -1) {
          arr_goodsNameSkus.push(goodsNameSkus);
          orderItems[i].goodsList = [
            JSON.parse(JSON.stringify(orderItems[i])),
          ];
          list.push(orderItems[i]);
        } else {
          list[index].goodsList.push(orderItems[i]);

        }
      }
      this.outCount=outCount
      this.tableData = list;
      console.log(this.tableData, "出库详情");
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      flex-shrink: 0;
      line-height: 24px;
    }
    .value {
      line-height: 24px;
    }
  }
}
</style>
